import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const CheckoutOptionCard = ({
  icon,
  title,
  description,
  accent = 'orange',
  isActive,
  onSelect,
  highlightText,
}) => {
  const { t } = useTranslation(['cart']);
  return (
    <button
      type="button"
      className={`checkout-option-card checkout-option-card--${accent} ${
        isActive ? 'checkout-option-card--active' : ''
      }`}
      onClick={onSelect}
    >
      <div className={`checkout-option-card__icon checkout-option-card__icon--${accent}`}>
        {icon}
      </div>
      <h3 className="checkout-option-card__title">{title}</h3>
      {highlightText ? (
        <p className="checkout-option-card__description">
          {description}
          <span className="checkout-option-card__highlight"> · {highlightText}</span>
        </p>
      ) : (
        <p className="checkout-option-card__description">{description}</p>
      )}
      <span className={`checkout-option-card__action checkout-option-card__action--${accent}`}>
        {t('selectOption')}
      </span>
    </button>
  );
};

CheckoutOptionCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  accent: PropTypes.oneOf(['orange', 'blue']),
  isActive: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  highlightText: PropTypes.string,
};

export default CheckoutOptionCard;
